import { render, staticRenderFns } from "./IconApproval.vue?vue&type=template&id=f6c68fb6"
import script from "./IconApproval.vue?vue&type=script&lang=js"
export * from "./IconApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports